module.exports = __webpack_public_path__ + "img/south-africa-logo-icon.4ecc739d.png";